import { PURCHASE_JOURNEY_CONTENT_FIELD_NAME, PURCHASE_JOURNEY_CONTENT_URL } from '@/lib/config';

type FetchPurchaseJourneyContentOptions = {
  endpoint?: string;
  fieldName?: string;
  fetcher?: typeof fetch;
};

const parseJsonIfString = (value: unknown): unknown => {
  if (typeof value !== 'string') {
    return value;
  }

  return JSON.parse(value);
};

export const extractPurchaseJourneyContentPayload = (
  responsePayload: unknown,
  fieldName = PURCHASE_JOURNEY_CONTENT_FIELD_NAME
): unknown => {
  const parsedPayload = parseJsonIfString(responsePayload);

  if (!parsedPayload || typeof parsedPayload !== 'object') {
    return parsedPayload;
  }

  const fieldMap = parsedPayload as Record<string, unknown>;
  const payload =
    fieldMap[fieldName] ??
    fieldMap.purchaseJourneyContent ??
    fieldMap.content ??
    fieldMap.contentJson ??
    fieldMap.json ??
    fieldMap.data;

  return parseJsonIfString(payload ?? parsedPayload);
};

export const getPurchaseJourneyContentEndpoint = () => PURCHASE_JOURNEY_CONTENT_URL;

export const fetchPurchaseJourneyContent = async ({
  endpoint = PURCHASE_JOURNEY_CONTENT_URL,
  fieldName = PURCHASE_JOURNEY_CONTENT_FIELD_NAME,
  fetcher = fetch,
}: FetchPurchaseJourneyContentOptions = {}): Promise<unknown | null> => {
  if (!endpoint) {
    return null;
  }

  const response = await fetcher(endpoint, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Unable to fetch purchase journey content: ${response.status}`);
  }

  return extractPurchaseJourneyContentPayload(await response.json(), fieldName);
};
